function init() {
	const collapseEls = document.querySelectorAll(".collapse");

	collapseEls.forEach(el => {
		el.addEventListener("click", function(e) {
			const toggledEl = document.getElementById(el.dataset.collapse);
			const parent = toggledEl.parentElement;

			if (toggledEl.classList.contains("collapse-item--opened")) {
				this.classList.remove("collapse--active");
				toggledEl.classList.remove("collapse-item--opened");
				parent.classList.remove("collapse-parent--opened");
				toggledEl.style.maxHeight = null;
			} else {
				toggledEl.style.maxHeight = toggledEl.scrollHeight + "px";
				this.classList.add("collapse--active");
				toggledEl.classList.add("collapse-item--opened");
				parent.classList.add("collapse-parent--opened");
			}
		});
	});
}

export default {
	init,
}
